import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class OneTimeFeeService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/sea-cables/doc-repairs/companies")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/sea-cables/doc-repairs/lic-docRepair")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getLicNumber2(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/tlm/lic-numbers?lic-business-id=8")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public SearchOneTime(querySearch?: any): Promise<any> {
    let url = "/api/business/sea-cables/doc-repairs";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  public excelTlm(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/sea-cables/doc-repairs/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
}
